import React, { FC, memo } from 'react'
import styled from 'styled-components'

import { Heading } from '@ucheba/ui/components/Heading/desktop'

import { Description } from '@ucheba/ui/components/Description/desktop/Description'
import { whatShouldWriteInReview } from './constants'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const WhatShouldWriteInReview: FC = () => (
  <Container>
    <Heading h3={whatShouldWriteInReview.title} spacing='xxsmall' />

    <Description spacing='xxsmall' description={whatShouldWriteInReview.text} />
  </Container>
)

export default memo(WhatShouldWriteInReview)
